/**
 * A tiny, valid one-page PDF built at runtime, used as the "attached invoice"
 * on seeded expenses. Rows with an attachment show the paperclip and offer
 * Download, and the download opens something real instead of a dead URL.
 *
 * The xref offsets are computed from the actual bytes, so viewers accept it.
 */
function buildInvoicePdf(): string {
  const objects = [
    "<</Type/Catalog/Pages 2 0 R>>",
    "<</Type/Pages/Kids[3 0 R]/Count 1>>",
    "<</Type/Page/Parent 2 0 R/MediaBox[0 0 420 180]/Contents 4 0 R/Resources<</Font<</F1 5 0 R>>>>>>",
    null, // the content stream, filled in below
    "<</Type/Font/Subtype/Type1/BaseFont/Helvetica>>",
  ];
  const text =
    "BT /F1 16 Tf 40 120 Td (Mock invoice) Tj ET\n" +
    "BT /F1 10 Tf 40 96 Td (fx-currency-expenses prototype) Tj ET\n" +
    "BT /F1 10 Tf 40 78 Td (No real document is attached.) Tj ET";
  objects[3] = `<</Length ${text.length}>>stream\n${text}\nendstream`;

  let pdf = "%PDF-1.4\n";
  const offsets: number[] = [];
  objects.forEach((body, index) => {
    offsets.push(pdf.length);
    pdf += `${index + 1} 0 obj\n${body}\nendobj\n`;
  });

  const xrefOffset = pdf.length;
  pdf += `xref\n0 ${objects.length + 1}\n0000000000 65535 f \n`;
  for (const offset of offsets) {
    pdf += `${String(offset).padStart(10, "0")} 00000 n \n`;
  }
  pdf += `trailer\n<</Size ${objects.length + 1}/Root 1 0 R>>\nstartxref\n${xrefOffset}\n%%EOF`;
  return pdf;
}

/** `data:` URL, so Download works with no server and survives a reload. */
export const INVOICE_PDF_URL = `data:application/pdf;base64,${btoa(buildInvoicePdf())}`;
